import React from 'react'

const NotAllowed = () => {
    return (
        <div>NotAllowed</div>
    )
}

export default NotAllowed